// https//github.com/daveyheuser/WP-ajax-like-button/blob/master/like-post.php

jQuery(document).ready(function($) {

    /***************************************
     ajax like shot feature
     ***************************************/
    $(document).on("click","a.like",function(e){
    // $(".like").stop().click(function(){

        let rel = $(this).attr("rel");

        let data = {
            data: rel,
            action: 'like_callback'
        }
        $.ajax({
            action: "like_callback",
            type: "GET",
            dataType: "json",
            url: ajaxurl,

            data: data,
            success: function(data){

                console.log(data.likes);
                console.log(data.status);

                if(data.status == true){
                    $(".like[rel="+rel+"]").html("<span>" + data.likes + "</span>").addClass("liked");
                }else{
                    $(".like[rel="+rel+"]").html("<span>" + data.likes + "</span>").removeClass("liked");
                }

            }
        });

    });

});
